<formly-form [form]="form" [fields]="fields">
</formly-form>
